import { StoreObject, gql, useApolloClient, useMutation } from '@apollo/client';
import { EpTechnologySkill, TechnologiesInput } from 'types/graphql-types';
import { useEmployee } from './use-employee';
import { useLoginInput } from './use-login-input';

const SAVE_TECHNOLOGIES = gql`
  mutation SaveTechnologies($technologies: TechnologiesInput!) {
    saveTechnologies(technologies: $technologies) {
      login
      technologies {
        name
        level
        desc
      }
    }
  }
`;

type SaveTechnologiesReturnType = {
  saveTechnologies: {
    login: string;
    technologies: EpTechnologySkill[];
  };
};

export const useSaveTechnologies = (): ((
  specialization: Omit<TechnologiesInput, 'login'>,
) => Promise<void>) => {
  const loginInput = useLoginInput();
  const { employee } = useEmployee();
  const client = useApolloClient();
  const [saveSpecialization] = useMutation(SAVE_TECHNOLOGIES, {
    onCompleted(data: SaveTechnologiesReturnType) {
      client.cache.modify({
        fields: {
          technologies() {
            return data.saveTechnologies.technologies;
          },
        },
        id: client.cache.identify(employee as unknown as StoreObject),
      });
    },
  });

  return async (technologies) => {
    const opt = {
      variables: { technologies: { ...loginInput, ...technologies } },
    };

    await saveSpecialization(opt);
  };
};
